export default __webpack_public_path__ + "static/karma-be14fa374005889c6fa18b367f483bc8.jpg";